import { createSlice } from "@reduxjs/toolkit";
import { ReportIdProps } from "../../forms/stepReportType/types";

const initialState: ReportIdProps = {
  rep_id: 0,
};

const uiReportIdReducer = createSlice({
  name: "reportid",
  initialState: initialState,
  reducers: {
    setReportId(state, action) {
      return {
        ...state,
        rep_id: action.payload,
      };
    },
  },
});

export default uiReportIdReducer.reducer;

export const { setReportId } = uiReportIdReducer.actions;
